import { useMemo } from 'react';

import { WorkflowNodesData, WorkflowNodeId, WorkflowNodeCampaign } from '../types';

/**
 * Creates a map between workflow node IDs and attached campaigns
 */
export const useCampaignsByWorkflowNodeId = (workflow: WorkflowNodesData) =>
  useMemo(
    () =>
      workflow.allNodes.reduce<Record<WorkflowNodeId, WorkflowNodeCampaign>>(
        (previousValue, node) => {
          if (node.resource?.campaign) {
            return { ...previousValue, [node.id]: { ...node.resource?.campaign, nodeId: node.id } };
          }
          return previousValue;
        },
        {},
      ),
    [workflow.allNodes],
  );
